import React, { useEffect } from "react";
import { StyleSheet, View } from 'react-native'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import _ from 'lodash'
import HelperString from 'utils/helper-string'
import ThemedBlock from 'components/atoms/ThemedBlock'
import ThemedItem from 'components/atoms/ThemedItem'
import i18n from 'utils/i18n'
import { AppRoutes } from 'navigations/app-routes'
import { useNavigation } from '@react-navigation/native'
import ThemedList from 'components/atoms/ThemedList'
import DataItem from 'components/atoms/DataItem'
import HelperArray from 'utils/helper-array'
import { colorList } from 'utils/colors'
import { DataItemStyles } from 'styles/components/atoms/DataItem'
import NoResultsView from 'components/atoms/NoResultsView'
import { constantsActive } from 'utils/constants/constants'
import ThemedPressable from 'components/atoms/ThemedPressable'
import FetchCachedBookingInvitationReceived from 'utils/fetch/cached/FetchCachedBookingInvitationReceived'
import FetchCachedBookingInvitationSent from 'utils/fetch/cached/FetchCachedBookingInvitationSent'
import { IconContainerStyles } from 'styles/components/atoms/IconContainer'
import selectBookings from 'services/redux/data/selectors/selectBookings'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import HelperDate, { dateFormat } from 'utils/helper-date'
import IconView from 'scenes/home/more/index/component/IconView'

const HomeBookStartInvitations = () => {
	const navigation = useNavigation();
	
	// Get all the invitations
	const _invitationsSent = useSelector( state => {
		return state.data[dataConstants.INVITATIONS_SENT];
	} )
	const _bookings = useSelector( selectBookings )
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} )
	
	// Make the invitation received the same layout as sent
	let invitationsReceived = {}
	_.forEach( _.filter( _bookings, o => {
		return o.booking_invitation !== null;
	} ), booking => {
		const invitation = booking.booking_invitation
		
		if( !( invitation.guid in invitationsReceived ) ) {
			invitationsReceived[ invitation.guid ] = {
				...invitation,
				sort_by: _.first( invitation.booking_dates ),
				bookings: []
			}
		}
		
		invitationsReceived[ invitation.guid ].bookings.push( booking )
	})
	
	// Sort the list and add data
	const currentYMD = HelperDate.date().format( dateFormat.DATE )
	const sortedInvitations = _.filter( _.map( _.orderBy( { ..._invitationsSent, ...invitationsReceived }, [ 'sort_by' ], [ 'asc' ] ), invitation => {
		if( invitation.active === constantsActive.NO ) {
			return null
		}
		
		let invitationInFuture = false
		_.forEach( _.get( invitation, 'booking_dates', [] ), date => {
			if( date >= currentYMD ) {
				invitationInFuture = true
			}
		})
		
		if( !invitationInFuture ) {
			return null;
		}
		
		invitation.booking_kinds = _.map( invitation.bookings, booking => {
			return booking?.kind;
		} )
		
		return invitation
	}) );
	
	const invitationIsSent = ( item ) => {
		return item?.employee?.guid === _employee?.guid
	}
	
	const onPressItem = ( item ) => {
		const isSent = invitationIsSent( item )
		
		navigation.navigate( isSent ? AppRoutes.INVITATION_SENT : AppRoutes.INVITATION_RECEIVED, {
			employee_booking_invitation_guid: item.guid,
		});
	}
	
	const renderItem = ( {item} ) => {
		const isSent = invitationIsSent( item )
		
		let invitationName = _.get( item, 'name', null );
		if( invitationName === null ) {
			invitationName = i18n.t('page.booking.calendar.invitations.item.name');
		}
		
		const bookingDates = _.get( item, 'booking_dates', [] )
		
		const dataItems = [];
		dataItems.push(
			<DataItem
				key={ HelperString.hash( 'invitation-data-item', item )}
				identifier={'day'}
				icon={ <Icon icon={ IconSystemConstants.CALENDAR } style={ [ DataItemStyles.headerIcon ] } size={ 9 } /> }
				content={ HelperArray.naturalJoin( bookingDates ) }>
				
				{ i18n.t( 'basic.day', { count: _.size( bookingDates ) } ) }
			</DataItem>
		)
		
		const icon = (
			<IconView>
				<View
					style={[ IconContainerStyles.iconContainer, styles.viewWidth40Height40 ]}>
					
					<Icon
						icon={ IconSystemConstants.PERSONS }
						size={ 24 }
						color={ colorList.ORANGE.primary }
					/>
				</View>
			</IconView>
		)
		
		return (
			<ThemedPressable
				key={ HelperString.hash( 'invitation-item', item )}
				onPress={ onPressItem.bind( this, item ) }>
				
				<ThemedItem
					accessoryLeft={ icon }
					accessoryLeftSize={ 40 }
					title={ invitationName }
					subtitle={ i18n.t(`page.booking.calendar.invitations.${ isSent ? 'sent' : 'received' }`) }
					items={ dataItems }
				/>
			</ThemedPressable>
		)
	}
	
	const fetch = () => {
		(async () => {
			FetchCachedBookingInvitationReceived.fetchAll();
			FetchCachedBookingInvitationSent.fetchAll();
		})();
	}
	
	useEffect( () => {
		return fetch();
	}, [] )
	
	if( _.size( sortedInvitations ) === 0 ) {
		return (
			<NoResultsView>
				{ i18n.t('page.booking.calendar.invitations.empty') }
			</NoResultsView>
		)
	}
	
	return (
		<ThemedBlock shadow>
			<ThemedList
				data={ sortedInvitations }
				renderItem={ renderItem.bind( this ) }
				style={ styles.themedList }
			/>
		</ThemedBlock>
	)
}

const styles = StyleSheet.create({
	viewWidth40Height40: {
		width: 40,
		height: 40,
	},
	themedList: {
		paddingHorizontal: 0,
	},
})

export default HomeBookStartInvitations
